import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {EuRegistrationService} from "../../../service/api/eu-registration.service";
import {EuEuRegistrationStatusInternal, EuRegistrationDto} from "../../../model/dto/entity/eu-registration.dto";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {DtoImportObjectContext} from "../../../../../core/shared/dto/dto.import.object.context";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {DtoList} from "../../../../../core/shared/dto/dto.list";
import {MvsObjectNavigationEntry} from "../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {MvsObjectNavigationActionEnum} from "../../../../../core/shared/navigation/mvs-object-navigation-action-enum";


@Component({
    selector: 'eu-registration-inline',
    templateUrl: 'eu-registration-inline.component.html',
    standalone: false
})
export class EuRegistrationInlineComponent implements OnInit, OnChanges {

    @Input() objectIdentifier: ObjectIdentifier;
    @Input() importObjectContext: DtoImportObjectContext;
    @Input() size: string = 'M';

    registrationDto: EuRegistrationDto;
    initialized: boolean;
    busy: boolean;

    statusLabel: string;
    statusColor: string;
    statusColorBackground: string;

    constructor(
        protected registrationService: EuRegistrationService,
        protected navigationService: MvsObjectNavigationService
    ) {
    }

    ngOnInit() {
        this.initComponent();
    }

    initComponent() {
        this.refreshComponent();
    }

    refreshComponent() {
        const filterCriteria = FilterCriteria.create('id', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId);
        const objectRequestList = ObjectRequestList.createBasic(false, [filterCriteria], []);

        this.registrationService.list(objectRequestList).subscribe((res: DtoList<EuRegistrationDto>) => {
            this.registrationDto = res.entries[0];
            this.setStatusDisplay();
            this.initialized = true;
        });
    }

    setStatusDisplay() {
        if (!this.registrationDto) {
            return;
        }

        switch (this.registrationDto.registrationStatusInternal) {
            case EuEuRegistrationStatusInternal.pending:
                this.statusLabel = 'Ausstehend';
                this.statusColor = 'orange-700';
                this.statusColorBackground = 'orange-100';
                break;
            case EuEuRegistrationStatusInternal.in_processing:
                this.statusLabel = 'In Bearbeitung';
                this.statusColor = 'blue-700';
                this.statusColorBackground = 'blue-100';
                break;
            case EuEuRegistrationStatusInternal.processed:
                this.statusLabel = 'Verarbeitet';
                this.statusColor = 'green-700';
                this.statusColorBackground = 'green-100';
                break;
            case EuEuRegistrationStatusInternal.unfinished_reminder:
                this.statusLabel = 'Erinnerung';
                this.statusColor = 'yellow-700';
                this.statusColorBackground = 'yellow-100';
                break;
            case EuEuRegistrationStatusInternal.unfinished_closed:
                this.statusLabel = 'Geschlossen';
                this.statusColor = 'red-700';
                this.statusColorBackground = 'red-100';
                break;
            case EuEuRegistrationStatusInternal.duplicate:
                this.statusLabel = 'Duplikat';
                this.statusColor = 'purple-700';
                this.statusColorBackground = 'purple-100';
                break;
            default:
                this.statusLabel = '';
                this.statusColor = '';
                this.statusColorBackground = '';
        }
    }

    getDisplayName(): string {
        if (!this.registrationDto) {
            return '';
        }

        const parts = [];
        if (this.registrationDto.firstName) {
            parts.push(this.registrationDto.firstName);
        }
        if (this.registrationDto.lastName) {
            parts.push(this.registrationDto.lastName);
        }

        return parts.length > 0 ? parts.join(' ') : this.registrationDto.phoneNumber || 'Registration';
    }

    handleClick(event?: MouseEvent) {
        const label = this.getDisplayName() || 'Registrierung';
        const navigationEntry = MvsObjectNavigationEntry.createNavigationEntry(
            this.objectIdentifier.objectType,
            this.objectIdentifier.objectId,
            null,
            label,
            null,
            null,
            MvsObjectNavigationActionEnum.display
        );
        navigationEntry['label'] = label;
        this.navigationService.addOverlay(navigationEntry);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!this.initialized) {
            return;
        }

        if (changes.objectIdentifier) {
            this.refreshComponent();
        }
    }
}
